export default __webpack_public_path__ + "static/media/average.d9b4dd6d.svg";